import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectLocationPlanCameraModel,
} from '../../models/project-location-plan-camera.model';

export const ProjectLocationPlanCameraActions = createActionGroup({
  source: 'PROJECT_LOCATION_PLAN_CAMERA',
  events: {
    'Reset to Initial state': emptyProps(),

    'Load project location plan cameras': props<{
      projectId: string
    }>(),
    'Load project location plan cameras success': props<{
      cameras: ProjectLocationPlanCameraModel.PlanCameraDocument[];
    }>(),
    'Load project location plan cameras fail': emptyProps(),

    //update many
    'Update project location plan cameras': props<{
      projectId: string;
      cameraIds: string[];
      changes: ProjectLocationPlanCameraModel.API.CameraSingleFieldUpdate;
    }>(),
    'Update project location plan cameras success': props<{
      cameraIds: string[];
      changes: ProjectLocationPlanCameraModel.API.CameraSingleFieldUpdate;
    }>(),
    'Update project location plan cameras fail': emptyProps(),

    //update one
    'Update project location plan camera': props<{
      cameraId: string;
      changes: ProjectLocationPlanCameraModel.API.UpdatePlanCameraDto;
      showToast?: boolean;
      optimistic?: boolean;
    }>(),
    'Update project location plan camera success': props<{
      camera: ProjectLocationPlanCameraModel.PlanCameraDocument;
    }>(),
    'Update project location plan camera fail': emptyProps(),

    'Load plan project cameras': props<{
      projectId: string,
      locationId: string,
      planId: string,
    }>(),
    'Load plan project cameras success': props<{
      cameras: ProjectLocationPlanCameraModel.PlanCameraDocument[]
    }>(),
    'Load plan project cameras fail': emptyProps(),

    'Save plan project camera': props<{
      projectId: string,
      locationId: string,
      planId: string,
      cameraData: ProjectLocationPlanCameraModel.API.CreatePlanCameraDto
    }>(),
    'Save plan project camera success': props<{
      camera: ProjectLocationPlanCameraModel.PlanCameraDocument
    }>(),
    'Save plan project camera fail': emptyProps(),

    'Copy camera': props<{
      cameraId: string;
    }>(),
    'Copy camera success': props<{
      camera: ProjectLocationPlanCameraModel.PlanCameraDocument;
    }>(),
    'Copy camera fail': emptyProps(),

    'Delete camera': props<{
      cameraId: string;
    }>(),
    'Delete camera success': props<{
      camera: ProjectLocationPlanCameraModel.PlanCameraDocument;
    }>(),
    'Delete camera fail': emptyProps(),

    'Bulk delete project location plan cameras': props<{
      projectId: string;
      cameraIds: string[];
    }>(),
    'Bulk delete project location plan cameras success': props<{
      cameraIds: string[];
    }>(),
    'Bulk delete project location plan cameras fail': emptyProps(),

    'Bulk create cameras': props<{
      projectId: string;
      cameras: ProjectLocationPlanCameraModel.API.BulkCreateCameraDto[];
    }>(),
    'Bulk create cameras success': props<{
      cameras: ProjectLocationPlanCameraModel.PlanCameraDocument[];
    }>(),
    'Bulk create cameras fail': emptyProps(),
  },
});
